import { Group, SimpleGrid, Checkbox, NumberInput } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { useTranslation } from 'react-i18next';
import { Indicator } from 'utils/models';
import { displayFormError } from 'utils/validation';

export const HeartRhythmTransitionFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, errors } = useCreateRuleFormContext();

  const transitionIndicators = [Indicator.Normal, Indicator.Urgent, Indicator.Warning];

  const dataField = 'data.heartRhythmTransition';

  const renderIndicatorLabels = (field: string, disabledField: string) => {
    return (
      <Checkbox.Group
        label={t(`${field}_label`)}
        {...getInputProps(`${dataField}.${field}`)}
        error={displayFormError({ errors, dataField: `${dataField}.${field}`, label: t('empty_value_select') })}
      >
        <SimpleGrid cols={2} verticalSpacing={'xs'} mb={'xs'}>
          {transitionIndicators.map((indicator) => (
            <Checkbox
              key={indicator}
              value={indicator}
              label={t(`indicator_label_${indicator}`)}
              disabled={
                getInputProps(`${dataField}.${disabledField}`).value.indexOf(indicator) > -1 || values.formDisabled
              }
            />
          ))}
        </SimpleGrid>
      </Checkbox.Group>
    );
  };

  return (
    <>
      <Group align={'top'}>
        {renderIndicatorLabels('from', 'to')}
        {renderIndicatorLabels('to', 'from')}
      </Group>
      <Group align={'top'}>
        <NumberInput
          label={t('required_measurements_label')}
          {...getInputProps(`${dataField}.numberOfMeasurements.amount`)}
          hideControls
          allowNegative={false}
          allowDecimal={false}
          min={1}
          max={100}
          disabled={values.formDisabled}
          clampBehavior={'strict'}
          error={displayFormError({ errors, dataField: `${dataField}.numberOfMeasurements.amount` })}
        />
      </Group>
      <Checkbox
        label={t('require_consecutive_label')}
        {...getInputProps(`${dataField}.numberOfMeasurements.isConsecutive`, {
          type: 'checkbox',
        })}
        disabled={values.formDisabled}
      />
    </>
  );
};
